import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SearchPref} from '../constants';

export const keywordIncludeContentsEnabled = () =>
	getPreference(SearchPref.KEYWORD_INCLUDE_CONTENTS_ENABLED, true);
